import { render, staticRenderFns } from "./pie-chart.vue?vue&type=template&id=6c3828c4&scoped=true"
import script from "./pie-chart.vue?vue&type=script&lang=js"
export * from "./pie-chart.vue?vue&type=script&lang=js"
import style0 from "./pie-chart.vue?vue&type=style&index=0&id=6c3828c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3828c4",
  null
  
)

export default component.exports